export default "/images/mdi_warning-outline.svg?53fdceb02ea85966ae34d4df7556ef42";